import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
    opacity: 0.5,
  },
  arrowWhite: {
    color: theme.palette.common.white,
  },
  tooltip: {
    backgroundColor: theme.palette.common.grey,
    fontSize: 12,
  },
  tooltipWhite: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    borderRadius: 8,
    padding: theme.spacing(1.5),
    opacity: 1,
    maxWidth: 441,
    whiteSpace: "pre-line",
    boxShadow: theme.shadows[2],
  },
}));
